module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-warmwasser-cb7d382b5a4f85648b026fe36384408a.svg";